import markdownIt from 'markdown-it';

export default (options = {}) => {
  const md = markdownIt({
    html: true,
    ...options,
  });

  return md;
};
